import { type NotificationShortUrl, ShortUrlObjectType } from '@air/api/types';

/**
 * The "via …" meta line on a notification that reached the user through a short url. Collection short
 * urls are called showcases in the UI; every other object type (board, asset, canvas, clip, form) is
 * still called a share link.
 */
export const getShortUrlNotificationMeta = (shortUrl: Pick<NotificationShortUrl, 'objectType'>) =>
  shortUrl.objectType === ShortUrlObjectType.collection ? 'via showcase' : 'via share link';
